import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@/utils/auth'
import UnexpectedEventDetail from '@/components/UnexpectedEvents/UnexpectedEventDetail'

export const Route = createFileRoute('/unexpected-events/$eventId')({
  beforeLoad: () => requirePermission('unexpected_events', 'read'),
  parseParams: params => ({ eventId: params.eventId }),
  component: UnexpectedEventDetail,
})
